import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Actions as ADVISORACTIONS } from "../../../store/actions/advisorActions";

import { format, parse } from "date-fns";
import { Actions as PAYMENTACTIONS } from "../../../store/actions/paymentActions";

import { CheckCircleIcon, ChevronDownIcon, CreditCardIcon } from "@heroicons/react/20/solid";

import { orderBy } from "lodash";
import PaymentMethods from "../../billing/SelectDefaultPaymentMethod";

import DatePicker from "react-datepicker";
import Select from "react-select";
import { DateInputFormat, handleRawDate } from "../../common/DateComponents";

// const Billing = ({
//     userPermissions,
//     showPricingModal,
//     updateCompanyDetails,
//     disabled,
//     selectedPlan,
//     selectedMethod,
//     paymentOptionsLength,
//     org,
//     currency,
//     forDashboard,
// }) => {
//     if (userPermissions === 'None') return <InvalidPermissions />
//     if (!org) return <LoadingContent />

//     const save = () => {
//         if (!selectedMethod?.value) {
//             NotificationManager.error('Payment Method cannot be empty', 'Saving Payment Method')
//             return
//         }
//         updateCompanyDetails(
//             cleanDeep({
//                 org: String(org),
//                 defaultCard: selectedMethod.value,
//             }, { emptyStrings: false, emptyArrays: false, emptyObjects: false }))
//         setChangeMethod(false)
//     }

//     return (
//         <>

//         </>
//     );
// };

const AdvisorBilling = ({
	advisorId,
	userId,
	setInviteAdvisorModalStatus,
	isOwner,
	isAdmin,
	selectedPlan,
	paymentOptionsLength,
	selectedMethod,
	currency,
	getAdvisorTeamMembers,
	getPaymentStats,
	changeAdvisorPlan,
	planOptions,
	setPartnerPlan,
	getAdvisorSettings,
	planRenewalDate,
	complimentaryUntil,
	trialExpiry,
	updateAdvisorDetails,
}) => {
	const [changeMethod, setChangeMethod] = useState();

	useEffect(() => {
		if (advisorId) {
			getAdvisorTeamMembers(advisorId);
			getPaymentStats(advisorId);
			getAdvisorSettings(advisorId);
		}
	}, [advisorId]);

	useEffect(() => {
		if (!selectedMethod) setChangeMethod(true);
	}, [selectedMethod]);

	return (
		<>
			<div className="content">
				<div className="block-content">
					<div className="col-lg-12 col-xs-12 form-section">
						{selectedPlan ? (
							<div className={`col-xs-12 form-container`}>
								<div className="pull-left">
									<h4>
										{selectedPlan?.name} Plan
										<div
											className="chip"
											style={{ background: "#ffdecd", color: "#ea611c" }}
										>
											{selectedPlan?.licenseDurationMonths == 12 ? "Yearly" : "Monthly"}
										</div>
									</h4>
									<p style={{ color: "#4d555d" }}>{selectedPlan?.description}</p>
								</div>
								<div className="pull-right">
									{selectedPlan?.price != 0 ? (
										<h1 className="leading-text">
											{" "}
											{selectedPlan?.discount
												? `${selectedPlan?.discount} Discount`
												: `${currency}${selectedPlan?.price}`}
											{selectedPlan?.discount ? (
												``
											) : (
												<span className="sub-text">
													per{" "}
													{selectedPlan?.licenseDurationMonths == 12 ? "year" : "month"}
												</span>
											)}
										</h1>
										) : (
											<div
												className="btn btn-default btn-success pull-right"
												onClick={changeAdvisorPlan}>
												Change Plan
											</div>
										)
									}
								</div>
								<div className="clearfix"></div>
							</div>
						) : (
							<div className={`col-xs-12 form-container`}>
								<div className="pull-left">
									<h4>Business Level Billing</h4>
									<p style={{ color: "#4d555d" }}>
										You are being billed on a per-company basis. If you are looking to explore
										Buddy's partner plans please get in touch with support.
									</p>
									<p style={{ color: "#4d555d" }}>
										Partner plans are exclusively available for Payroll Bureaus & Service Providers.
									</p>
								</div>
							</div>
						)}
					</div>
					{isAdmin && (
						<div className="col-lg-12 col-xs-12 form-section">
							<div className={`col-xs-12 form-container`}>
								<h4>Admin - Set Partner Plan</h4>
								<div className="form-material">
									<Select
										options={planOptions}
										value={selectedPlan}
										onChange={setPartnerPlan}
										name="plan"
									/>
								</div>

								<div
									className="form-material"
									style={{ marginTop: 35 }}
								>
									<label>Plan Renewal Date</label>
									<DatePicker
										selected={planRenewalDate}
										onChange={(newRenewalDate, o, e) => {
											console.log("valueRenew", newRenewalDate, o, e);
											updateAdvisorDetails({
												id: advisorId,
												detailsToUpdate: {
													planRenewalDate: format(newRenewalDate, "yyyy-MM-dd"),
												},
											});
										}}
										dateFormat="dd MMM yyyy"
										customInput={<DateInputFormat />}
										onChangeRaw={(e) =>
											handleRawDate(e.target.value, (newRenewalDate) => {
												updateAdvisorDetails({
													id: advisorId,
													detailsToUpdate: {
														planRenewalDate: format(newRenewalDate, "yyyy-MM-dd"),
													},
												});
											})
										}
										strictParsing
									/>
								</div>


								<div
									className="form-material"
									style={{ marginTop: 35 }}
								>
									<label>Trial Expiry Date</label>
									<DatePicker
										selected={trialExpiry}
										onChange={(newTrialExpiryDate, o, e) => {
											console.log("valueRenew", newTrialExpiryDate, o, e);
											updateAdvisorDetails({
												id: advisorId,
												detailsToUpdate: {
													trialExpiry: format(newTrialExpiryDate, "yyyy-MM-dd"),
												},
											});
										}}
										dateFormat="dd MMM yyyy"
										customInput={<DateInputFormat />}
										onChangeRaw={(e) =>
											handleRawDate(e.target.value, (newRenewalDate) => {
												updateAdvisorDetails({
													id: advisorId,
													detailsToUpdate: {
														planRenewalDate: format(newRenewalDate, "yyyy-MM-dd"),
													},
												});
											})
										}
										strictParsing
									/>
								</div>

								<div
									className="form-material"
									style={{ marginTop: 35 }}
								>
									<label>Complimentary Until</label>
									<DatePicker
										selected={complimentaryUntil}
										onChange={(newRenewalDate, o, e) => {
											console.log("valueRenew", newRenewalDate, o, e);
											updateAdvisorDetails({
												id: advisorId,
												detailsToUpdate: {
													complimentaryUntil: format(newRenewalDate, "yyyy-MM-dd"),
												},
											});
										}}
										dateFormat="dd MMM yyyy"
										customInput={<DateInputFormat />}
										onChangeRaw={(e) =>
											handleRawDate(e.target.value, (newRenewalDate) => {
												updateAdvisorDetails({
													id: advisorId,
													detailsToUpdate: {
														complimentaryUntil: format(newRenewalDate, "yyyy-MM-dd"),
													},
												});
											})
										}
										strictParsing
									/>
								</div>
							</div>
						</div>
					)}
					<div className="col-lg-12 col-xs-12 form-section">
						<div className="col-xs-12">
							<div className="pull-left">
								<h4>Payment Method</h4>
								<p style={{ color: "#4d555d" }}>Change how you pay for your plan</p>
							</div>
							{paymentOptionsLength && selectedMethod ? (
								<div
									className="btn btn-default pull-right"
									style={{ paddingRight: 6 }}
									onClick={() => setChangeMethod(!changeMethod)}
								>
									<div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>
										Switch Payment Method
									</div>
									<ChevronDownIcon
										style={{
											height: "1.5em",
											float: "left",
											transform: changeMethod ? "rotate(180deg)" : "rotate(0deg)",
											transition: "transform 0.2s ease-in-out",
										}}
									/>
								</div>
							) : null}
						</div>
						{changeMethod ? (
							<PaymentMethods advisorCharge={true} />
						) : (
							<div
								className="col-xs-12"
								style={{ marginBottom: "2rem" }}
							>
								<div className="pull-left">
									<div
										className="chip"
										style={{ background: "#ffdecd", marginRight: "2rem" }}
									>
										<CreditCardIcon style={{ height: "2.5rem", color: "#ea611c" }} />
									</div>
								</div>
								<div className="pull-left">
									{selectedMethod ? (
										<>
											<span className="sup-text">
												{selectedMethod?.brand
													?.split(" ")
													?.map((c) => c[0].toUpperCase() + c.substring(1).toLowerCase())
													.join(" ")}{" "}
												ending in {selectedMethod?.last4}
											</span>
											<p className="sub-text">Expires on {selectedMethod?.expiry}</p>
										</>
									) : (
										<>
											<span className="sup-text">No Payment Methods Found</span>
											<p className="sub-text">Add one in Company Settings</p>
										</>
									)}
								</div>
							</div>
						)}
						<div className="clearfix" />
					</div>
					<div
						className="col-xs-12 text-right"
						style={{ paddingRight: 0 }}
					>
						{isOwner && (
							<button
								className="btn btn-default btn-success"
								style={{ marginRight: "5" }}
								type="submit"
								onClick={() => console.log("need to save!")}
							>
								<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Save</div>
							</button>
						)}
					</div>
					<div className="clearfix" />
				</div>
			</div>
		</>
	);
};

// const mapStateToProps = (state) => {

//     return {
//         org: state.company?.settings?.org,
//         disabled: userPermissions == 'Read',
//         selectedPlan,
//         paymentOptionsLength: paymentOptions?.length > 0,
//         selectedMethod,
//         userPermissions,
//         // businessDetails: state?.payment?.stats?.businessDetails,
//         addNewCard: state.payment.stripe && state.payment.stripe.addNewCard,
//         stripePaymentMethods: state.payment.stripe && state.payment.stripe.paymentMethods,
//         paymentIntent: state.payment.stripe && state.payment.stripe.paymentIntent,
//         processingStripeCharge: state.payment.stripe && state.payment.stripe.processingCharge,
//         currency: state.company?.settings?.currency,
//         bundles,
//         planOptions,
//     }
// }

// const mapDispatchToProps = dispatch => ({
//     showPricingModal: (isNew) => dispatch(PAYMENTACTIONS.showPricingModal(true, isNew ?? false)),
//     getCredits: ({ before, after }) => dispatch(PAYMENTACTIONS.getCredits({ before, after })),
//     getPayPeriods: () => dispatch(PAYPERIODACTIONS.getPayPeriods()),
//     setBillingModal: (billingModal) => dispatch(COMPANYACTIONS.setBillingModal(billingModal)),
//
//     updateCompanyDetails: (body) => dispatch(COMPANYACTIONS.updateCompanyDetails(body)),
// });

const mapStateToProps = (state) => {
	const userPermissions = state?.permissions?.my?.permissions?.billing;
	const currency = state.advisors?.settings?.jurisdiction == "UK" ? "£" : "€";

	const paymentOptions =
		state.payment?.stripe?.paymentMethods?.map((item) => ({
			value: item.id,
			label: `•••• •••• •••• ${item.card.last4} - ${item.card.exp_month}/${item.card.exp_year}`,
			brand: item.card.brand,
			last4: item.card.last4,
			expiry: `${item.card.exp_month}/${item.card.exp_year}`,
			email: item.billing_details.email,
			phone: item.billing_details.phone,
		}));

	const bundles =
		state.payment.bundles &&
		orderBy(
			state.payment.bundles.filter((b) => b.isPartnerPlan),
			["credits"],
			["asc"],
		);

	const planOptions = bundles?.map((item) => ({
		...item,
		value: item.id,
		label: `${item.name} ${
			item.licenseDurationMonths
				? `- ${currency}${item.price}/${item.licenseDurationMonths == 1 ? "Month" : "Year"}`
				: item.discount ? `-  ${item.discount} Discount` : ``
		}`,
	}));
	const selectedPlan = planOptions?.find((item) => item.value == state.advisors?.settings?.plan);
	const selectedMethod = paymentOptions?.find((item) => item.value == state.advisors?.settings?.defaultCard);

	const advisorTeam = state.advisors.team || [];
	const { id: userId, advisorId } = state.my.profile;
	const isOwner = advisorTeam.find((a) => a.userId === userId)?.status === "Owner";

	return {
		selectedPlan,
		planOptions,
		paymentOptionsLength: paymentOptions?.length > 0,
		planRenewalDate: state.advisors?.settings?.planRenewalDate
			? parse(state.advisors?.settings?.planRenewalDate, "yyyy-MM-dd", new Date())
			: null,
		trialExpiry: state.advisors?.settings?.trialExpiry
			? parse(state.advisors?.settings?.trialExpiry, "yyyy-MM-dd", new Date())
			: null,
		complimentaryUntil: state.advisors?.settings?.complimentaryUntil
			? parse(state.advisors?.settings?.complimentaryUntil, "yyyy-MM-dd", new Date())
			: null,
		selectedMethod,
		userPermissions,
		advisorId,
		userId,
		isOwner,
		isAdmin: state.my?.profile?.isAdmin,
		currency,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
  	changeAdvisorPlan: () => dispatch(ADVISORACTIONS.showPricingModal(true)),
	getAdvisorTeamMembers: (advisorId) => dispatch(ADVISORACTIONS.getAdvisorTeamMembers(advisorId)),
	getPaymentStats: (id) => dispatch(PAYMENTACTIONS.getPaymentStats(id)),
	setPartnerPlan: (plan) => dispatch(ADVISORACTIONS.setPartnerPlan(plan)),
	updateAdvisorDetails: (details) => dispatch(ADVISORACTIONS.updateAdvisorDetails(details)),
	getAdvisorSettings: (id) => dispatch(ADVISORACTIONS.getAdvisorSettings(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorBilling);
